import React from "react";
import { useController } from "react-hook-form";

export default function useFormField(form, name, rules) {
  const { field } = useController({ control: form.control, name, rules });
  const { getValues, setValue } = form;
  const setField = React.useCallback(
    (next) => {
      setValue(
        name,
        typeof next === "function" ? next(getValues(name)) : next,
        { shouldDirty: true, shouldTouch: true, shouldValidate: true },
      );
    },
    [getValues, setValue, name],
  );
  return [field.value, setField];
}
